import { useQuery } from '@tanstack/react-query'

import { useQueryWithStorage } from '@hooks/useQueryWithStorage'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchWerklijsten, initialState } from '../services/fetchWerklijsten'

import { useWerklijstenStore } from './useWerklijstenStore'

export { useWerklijsten, queryKey }

const queryKey = 'hoofdleiding-dashboard-werklijsten'

const useQueryStore = () => {
  const { query, storeQuery } = useWerklijstenStore()

  return useQueryWithStorage({
    initialState: initialState,
    query,
    storeQuery,
    queryKey,
  })
}

const useWerklijsten = () => {
  const { onChangeFilters, onReset, query } = useQueryStore()
  const { hasPermissions } = useAuthenticatedUser()

  const { data, refetch, isFetching, isError } = useQuery({
    queryKey: [queryKey, query],
    queryFn: () => fetchWerklijsten({ query }),
    enabled: hasPermissions,
    refetchOnMount: true,
  })

  return {
    data: data || initialState.data,
    isLoading: isFetching,
    isError,
    filters: query.filters,
    initialFilters: initialState.query.filters,
    onChangeFilters,
    onReset,
    onRefresh: refetch,
  }
}
